export enum UserRole {
  Admin = 'admin',
  Employeur = 'employeur',
  Salarie = 'assure_salarie',
  Retraite = 'assure_retraite',
  Volontaire = 'assure_volontaire',
}
